import { Divider, Stack } from '@mui/material';

import FooterSkeleton from './Footer/skeleton';
import HeaderSkeleton from './Header/skeleton';
import PollQuestionSkeleton from './PollQuestion/skeleton';
import { Content, pollPageClasses } from './styles';

const PollSkeleton = () => {
  return (
    <Stack gap={4} px={4} py={2} height="100%">
      <HeaderSkeleton />
      <Divider />
      <Content flex={1}>
        <PollQuestionSkeleton className={pollPageClasses.questionForm} />
        <FooterSkeleton />
      </Content>
    </Stack>
  );
};

export default PollSkeleton;
